import React, {useContext} from 'react';

import VaWrap from '../../VaWrap/VaWrap';
import StayContext from '../../context/StayContext';
import RefundInfoContext from '../../context/RefundInfoContext';
import {INTENTS, SKILL_TYPE} from '../../molecules/VaFloating/constants';

export const RefundVAWrapper = () => {
    const {
        stay: {
            booking: {reservationUuid},
        },
    } = useContext(StayContext);
    const {
        actionLocation,
        chatWidgetCounter,
        isLoading,
        showRefundInfo,
        updateIsLoading,
    } = useContext(RefundInfoContext);

    if (!showRefundInfo) {
        return null;
    }

    return (
        <VaWrap
            autoOpen
            chatWidgetCounter={chatWidgetCounter}
            eventsInfo={{
                actionLocationEDAP: actionLocation,
                skillType: SKILL_TYPE.REFUND_STATUS,
            }}
            intent={INTENTS.REFUND_STATUS}
            isLoading={isLoading}
            otherIntentProps={{
                reservationUuid,
            }}
            updateIsLoading={updateIsLoading}
        />
    );
};
